import { getAnnuityFactor } from "shared/getAnnuityFactor";
import { GOAL_REAL_YIELD } from "web_myplann/Goals/constants";

export const calcRentPresentValue = (
	monthly: number,
	months: number,
): number => {
	if (monthly <= 0 || months <= 0) return 0;
	return monthly * getAnnuityFactor(GOAL_REAL_YIELD / 12, months);
};
